import _ from 'lodash'

export default function getAllPossiblePaths(key, variants = [], options = {}) {
  const combinations = getSubsets(variants)
  const splitedKeys = _.split(key, '.')
  const { variantsPosition = -1 } = options
  const chunkSize = _.clamp(
    variantsPosition >= 0
      ? variantsPosition
      : _.size(splitedKeys) + variantsPosition,
    0,
    _.size(splitedKeys),
  )
  const chunkedKeys = chunkSize === 0 ? [splitedKeys, []] : _.chunk(splitedKeys, chunkSize)
  return _.map(
    combinations,
    (c) => (
      _.join(
        [
          ...(_.first(chunkedKeys) || []),
          ..._.map(c, _.camelCase),
          ...(_.last(chunkedKeys) || [key]),
        ],
        '.',
      )
    ),
  )
}

// Private function
/**
 * Generate all possible subsets of the given array, sorted by size in descending order.
 *  input: ['a', 'b', 'c', 'd']
 *  output: [
 *   ["a","b","c","d"],
 *   ["a","b","c"],
 *   ["a","b","d"],
 *   ["a","c","d"],
 *   ["b","c","d"],
 *   ["a","b"],
 *   ["a","c"],
 *   ["a","d"],
 *   ["b","c"],
 *   ["b","d"],
 *   ["c","d"],
 *   ["a"],
 *   ["b"],
 *   ["c"],
 *   ["d"],
 *   []
 * ]
 *
 * @param {Array} arr - The input array
 * @return {Array} The sorted list of all possible subsets
 */
function getSubsets(arr) {
  const result = [];
  const recurse = (current, remaining) => {
    result.push(current);
    _.forEach(
      remaining,
      (remainingItem, index) => {
        recurse(
          _.concat(current, remainingItem),
          _.drop(remaining, index + 1),
        )
      },
    )
  }
  recurse([], arr);
  const sortedList = _.sortBy(
    result,
    [
      _.size,
      (list) => (
        _.sumBy(list, (key) => (_.size(arr) - _.indexOf(arr, key)))
      ),
    ],
  )
  return _.reverse(sortedList);
}
